import { useState, useEffect } from 'react'
import { Box, Typography, FormControl, FormControlLabel, FormHelperText, Checkbox, Link } from '@mui/material'

function TermsAndConditions ({ onValidationChange, showErrors, formData, onFormDataChange }) {
  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    const { name, checked } = e.target
    onFormDataChange({ [name]: checked })
  }

  useEffect(() => {
    const newErrors = {}
    if (!formData.termsAndConditions) newErrors.termsAndConditions = 'You must agree to the Code of Rights.'
    if (!formData.privacyStatement) newErrors.privacyStatement = 'You must agree to the Privacy Statement.'
    setErrors(newErrors)
    onValidationChange(Object.keys(newErrors).length === 0)
  }, [formData, onValidationChange])

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant='h6'>Code of Rights/Privacy Statement</Typography>
      <FormControl required error={showErrors && !!errors.termsAndConditions}>
        <FormControlLabel
          control={<Checkbox
            name='termsAndConditions'
            checked={formData.termsAndConditions || false}
            onChange={handleChange}
                   />}
          label={
            <>
              I have read and agree to the{' '}
              <Link href='https://birthcare.co.nz/your-rights/' target='_blank' rel='noopener noreferrer'>
                Code of Rights
              </Link>{' '}
            </>
                  }
          sx={{ mt: 1 }}
        />
        {showErrors && errors.termsAndConditions && (<FormHelperText>{errors.termsAndConditions}</FormHelperText>)}
      </FormControl>

      <FormControl required error={showErrors && !!errors.privacyStatement}>
        <FormControlLabel
          control={<Checkbox
            name='privacyStatement'
            checked={formData.privacyStatement || false}
            onChange={handleChange}
                   />}
          label={
            <>
              I have read and agree to the{' '}
              <Link href='https://birthcare.co.nz/privacy-statement/' target='_blank' rel='noopener noreferrer'>
                Privacy Statement
              </Link>{' '}
            </>
          }
          sx={{ mt: 1 }}
        />
        {showErrors && errors.privacyStatement && (<FormHelperText>{errors.privacyStatement}</FormHelperText>)}
      </FormControl>
    </Box>
  )
}

export default TermsAndConditions
